import hpyGlobalsClass from './helper/globals';
// import { Navigation } from './navigation/_navigation';
import footerColDropDown from './main/footerDropdown';
import scrollToHash from './main/scrollToHash';
// import StickyHeader from './main/stickyHeader';
import scrollToTop from './main/scrollToTop';

window.hpyGlobals = new hpyGlobalsClass();

(function ($) {
	"use_strict";

	gsap.registerPlugin(ScrollToPlugin)

	// checkout payment selection
	$('.woocommerce-checkout .wc_payment_methods input[type="radio"]:checked').prop('checked', true);

	footerColDropDown();
	// scrollToHash();
	// new StickyHeader();
	scrollToTop();

})(jQuery);
